import { FetchCollections } from "../../Services/MainServices";
import { toast } from "react-toastify";

export const COLLECTION_DETAIL_REQUEST = "COLLECTION_DETAIL_REQUEST";
export const COLLECTION_DETAIL_SUCCESS = "COLLECTION_DETAIL_SUCCESS";
export const COLLECTION_DETAIL_FAILURE = "COLLECTION_DETAIL_FAILURE";

// For specific category collections
export const COLLECTION_CAT_DETAIL_REQUEST = "COLLECTION_CAT_DETAIL_REQUEST";
export const COLLECTION_CAT_DETAIL_SUCCESS = "COLLECTION_CAT_DETAIL_SUCCESS";
export const COLLECTION_CAT_DETAIL_FAILURE = "COLLECTION_CAT_DETAIL_FAILURE";

export const getCollectionDetail = (category) => async (dispatch) => {
  dispatch({ type: COLLECTION_DETAIL_REQUEST });

  try {
    const response = await FetchCollections("all");
    if (response.status === 200 && response.data?.data) {
      const subCategories = response.data.data;
      dispatch({ type: COLLECTION_DETAIL_SUCCESS, payload: subCategories });
      // toast.success(`${category.charAt(0).toUpperCase() + category.slice(1)} Collection Fetched Successfully !!`)
    } else {
      dispatch({
        type: COLLECTION_DETAIL_FAILURE,
        payload: "Collection not found",
      });
    }
  } catch (error) {
    dispatch({
      type: COLLECTION_DETAIL_FAILURE,
      payload: error.response?.data?.data || error.message,
    });
  }
};

export const getSpecificCollectionDetail = (category) => async (dispatch) => {
  dispatch({ type: COLLECTION_CAT_DETAIL_REQUEST });

  try {
    const response = await FetchCollections(category);
    if (response.status === 200 && response.data?.data) {
      const subCategories = response.data.data;
      dispatch({ type: COLLECTION_CAT_DETAIL_SUCCESS, payload: subCategories });
      // toast.success(`${category.charAt(0).toUpperCase() + category.slice(1)} Collection Fetched Successfully !!`)
    } else {
      dispatch({
        type: COLLECTION_CAT_DETAIL_FAILURE,
        payload: "Collection not found",
      });
    }
  } catch (error) {
    dispatch({
      type: COLLECTION_CAT_DETAIL_FAILURE,
      payload: error.response?.data?.data || error.message,
    });
  }
};
